import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppContext } from '@/Main';
import ChildrensTooltip from '@/components/common/ChildrensTooltip';
import SettingsPanel from '@/components/settings-panel/SettingsPanel';

type ThemeControlDropdownProps = {
  iconClassName?: string;
};

const ThemeControlDropdown = ({
  iconClassName = 'fs-1'
}: ThemeControlDropdownProps) => {
  const { setConfig } = useAppContext();

  const handleClick = () => {
    setConfig('showSettingPanel', true);
  };

  return (
    <>
      <ChildrensTooltip
        delayToRemove={100}
        placement="bottom"
        showOnHover={false}
        html="تنظیمات ظاهری"
      >
        <Button
          onClick={() => {
            handleClick();
          }}
          variant="link"
          className="nav-link d-flex align-items-center pe-1"
        >
          <FontAwesomeIcon icon="palette" className={iconClassName} />
        </Button>
      </ChildrensTooltip>
      <SettingsPanel />
    </>
  );
};

export default ThemeControlDropdown;
